const cardArtist = function cardArtist(data) {
  let cardClass;
  let arrCardImage = [];
  let cardImg;
  let cardDescription;
  
  for (i=0; i<data.length; i++){
    row = data[i];
    cardImg = "";
    cardDescription = "";

    if (row.image) {
     cardImg = '<img src="'+row.image+'" alt="'+row.seller_name+'">';
    }
    if (row.description != undefined || row.description != null) {
      cardDescription = '<p>'+row.description+'</p>';
    }
    $('[data-vendor_image="' + row.seller_name + '"]').html(cardImg);
    $('[data-vendor_description="' + row.seller_name + '"]').html(cardDescription);
  }

  function checkOverflow() {
    document.querySelectorAll('.c-artist-list li').forEach((item) => {
      var description = item.querySelector('.product__description');
      var toggleText = item.querySelector('.toggle_text');
      var readMoreContent = item.querySelector('.read_more_content');
    
      if (description) {
        var descriptionHeight = description.scrollHeight;

        if (descriptionHeight <= 79) {
          if (toggleText) {
            toggleText.style.display = 'none';
          }
          if (readMoreContent) {
            readMoreContent.classList.add('gradient_hidden');
            readMoreContent.classList.remove('read_more_content_gradient');
          }
        } else {
          if (toggleText) {
            toggleText.style.display = 'block';
          }
          if (readMoreContent) {
            readMoreContent.classList.remove('gradient_hidden');
            readMoreContent.classList.add('read_more_content_gradient');
          }
        }
      }
    });  
  }

  setTimeout(function(){
    checkOverflow();
/*
    const list = document.getElementById("c-artist-list");

    if (list.length > 0) {
      const items = Array.from(list.children);

      // シャッフル関数
      function shuffle(array) {
          for (let i = array.length - 1; i > 0; i--) {
              const j = Math.floor(Math.random() * (i + 1));
              [array[i], array[j]] = [array[j], array[i]];
          }
      }
    
      shuffle(items);
    
      // ランダム化したリストを再描画
      list.innerHTML = "";
      items.forEach(item => list.appendChild(item));
    }    
*/
  var $ul = $('#c-artist-list');
  var $li = $ul.children('li');

  // li を配列にしてランダムに並び替え
  $li.sort(function () {
    return Math.random() - 0.5;
  });

  // 並び替えた要素をulに再追加
  $ul.empty().append($li);    

    $('#c-artist-list').css('visibility','visible');
    $('#c-artist-list').show();
  }, 500);

  // $(window).on('resize', function() {
  //     checkOverflow();
  // });

  // チェックボックスがクリックされたときの処理  
  $('.read_more_showtext').on('change', function() {
    if ($(this).is(':checked')) {
      $(this).closest('li').find('.read_more_content').removeClass('read_more_content_gradient');        
    } else {
      $(this).closest('li').find('.read_more_content').addClass('read_more_content_gradient'); 
    }
  });
/*
    document.querySelectorAll('.c-artist__artist--desc').forEach((item) => {
  
      const checkbox = item.querySelector('.read_more_showtext');
      const toggleText = item.querySelector('.toggle_text');
      const readMoreContent = item.querySelector('.read_more_content');
    
      // checkboxの状態が変更されたときのイベントリスナーを追加
      checkbox.addEventListener('change', () => {
        if (checkbox.checked) {
          // チェックされている場合
          if (toggleText) {
            toggleText.textContent = '元に戻す'; // テキストを「元に戻す」に変更
          }
          if (readMoreContent) {
            readMoreContent.classList.add('gradient_hidden'); // gradient_hiddenクラスを追加
          }
        } else {
          // チェックが外れた場合
          if (toggleText) {
            toggleText.textContent = 'すべて見る'; // テキストを「もっと見る」に変更
          }
          if (readMoreContent) {
            readMoreContent.classList.remove('gradient_hidden'); // gradient_hiddenクラスを削除
          }
        }
      });
    });
  }
*/
}

// c-artist__artistの個数取得
function getCardArtistVendor() {
  let param;
  if ($('.c-artist__artist__info').length > 0) {
    let arrVendor = [];
    let vendor;
    for (let i=0; i<$('.c-artist__artist__info').length; i++) {
      vendor = "arr_seller_name[]="+$('.c-artist__artist__info .c-artist__artist--name').eq(i).attr('data-vendor');
      if($.inArray(vendor, arrVendor) == -1) {
        arrVendor.push(vendor);
      }
    }

    // get用のパラメータ作成
    param = "?"+arrVendor.join("&");
  }

  return param;
}

const doCardArtistVendor = function(){
  let param = getCardArtistVendor();
  fetchBase(mallDomain + "/api/shop"+param, cardArtist);
}

doCardArtistVendor();

